import { useCallback, useRef } from "react";

export function useThrottleFn<T extends (...args: unknown[]) => void>(
  fn: T,
  delay: number,
) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastTimeRef = useRef<number>(0);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();
      const timeSinceLastCall = now - lastTimeRef.current;

      if (timeSinceLastCall >= delay) {
        fn(...args);
        lastTimeRef.current = now;
      }
    },
    [fn, delay],
  );
}
